import { useNavigate } from 'react-router-dom';
import type { EconRun } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { Progress } from '@shared/ui/Progress';
import { IconArrowRight } from '@shared/ui/icons';
import { fmtPeriod, isRunActive, statusLabel, statusTone } from '@entities/economic/types';
import {
  EmptyState,
  ListHead,
  Muted,
  OpenHint,
  RunCard,
  RunMeta,
  RunPeriod,
  RunTop,
  Stack,
} from './styles';

export function RunsList({
  runs,
  isFetching,
  isLoading,
}: {
  runs: EconRun[];
  isFetching: boolean;
  isLoading: boolean;
}) {
  const navigate = useNavigate();
  return (
    <Stack>
      <ListHead>
        <Muted>Обработок: {runs.length}</Muted>
        {isFetching && <Muted>обновление…</Muted>}
      </ListHead>

      {runs.map((r) => (
        <RunCard
          key={r.id}
          $accent
          role="button"
          tabIndex={0}
          onClick={() => navigate(`/agents/econ/runs/${r.id}`)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              navigate(`/agents/econ/runs/${r.id}`);
            }
          }}
        >
          <RunTop>
            <RunPeriod>{fmtPeriod(r.period)}</RunPeriod>
            <Badge $tone={statusTone(r.status)}>{statusLabel(r.status)}</Badge>
          </RunTop>
          {isRunActive(r.status) && <Progress percent={r.progress_percent} />}
          <RunMeta>
            {r.object_scope && <span>{r.object_scope}</span>}
            <span title="Автор обработки">{r.author_name ?? 'система'}</span>
            <span>{new Date(r.created_at).toLocaleDateString('ru-RU')}</span>
            <OpenHint>
              Открыть
              <IconArrowRight size={14} />
            </OpenHint>
          </RunMeta>
        </RunCard>
      ))}

      {runs.length === 0 && !isLoading && (
        <EmptyState>
          Пока нет обработок в этом модуле. Загрузите документы за период слева и запустите расчёт.
        </EmptyState>
      )}
    </Stack>
  );
}
